import { isMaieShell } from './maieShell';

/**
 * WHERE A FINISHED NOTE OPENS.
 *
 * The design shell ends a consult on `/encounter/:id` — the editable note with
 * S/O/A/P and the sign action. The previous shell has no such screen and keeps
 * `/encounter/:id/review`, which it was built around.
 *
 * There are FOUR places a doctor arrives at a fresh note from: the dock's
 * post-synth navigate, the background pill, the bridge's success toast, and
 * anything that links a record directly. They were four literals, so a consult
 * captured in the new design could still exit into the old one depending on
 * whether the doctor had minimised the synth overlay. One function instead.
 */
export function noteRoute(recordId: string): string {
  return isMaieShell() ? `/encounter/${recordId}` : `/encounter/${recordId}/review`;
}
